import { VxeUI } from '@vxe-ui/core';
const { log } = VxeUI;
const version = `table v${"3.13.26"}`;
export const warnLog = log.create('warn', version);
export const errLog = log.create('error', version);
